import { useContext } from 'react';
import VendorBoothContext from '../contexts/VendorBoothContext';
import type { IVendorBoothContext } from '../contexts/VendorBoothContext';

const useVendorBooth = (): IVendorBoothContext => useContext(VendorBoothContext);

export default useVendorBooth;
